import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "add-bank-card" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "submit-wrapper" }
const _hoisted_4 = { class: "bank-list" }
const _hoisted_5 = { class: "list-content" }

import { reactive, ref, onBeforeUnmount, onMounted } from 'vue'
import { showToast } from 'vant'
import { getBindCardCode, getBankList, bindCard } from '@/api/wallet'

interface FormData {
  cardHolder: string
  cardNumber: string
  phone: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AddBankCard',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const formData = reactive<FormData>({
  cardHolder: '',
  cardNumber: '',
  phone: '',
})

const authData = ref<any>({
  authSn: '',
  requestNo: '',
  smsCode: ''
})

const bankList = ref<any[]>([])

// 添加倒计时相关状态
const counting = ref(false)
const countdown = ref(60)
let timer: ReturnType<typeof setInterval> | null = null

// 表单校验规则
const validateForm = () => {
  if (!formData.cardHolder) {
    showToast('请输入持卡人姓名')
    return false
  }
  if (!formData.cardNumber) {
    showToast('请输入银行卡号')
    return false
  }
  if (!/^\d{16,19}$/.test(formData.cardNumber)) {
    showToast('请输入正确的银行卡号')
    return false
  }
  if (!formData.phone) {
    showToast('请输入手机号')
    return false
  }
  if (!/^1[3-9]\d{9}$/.test(formData.phone)) {
    showToast('请输入正确的手机号')
    return false
  }
  return true
}

// 获取验证码
const getVerificationCode = async () => {
  if (counting.value) return
  if (!formData.cardNumber) {
    showToast('请输入银行卡号')
    return
  }
  if (!formData.phone) {
    showToast('请输入手机号')
    return
  }
  if (!/^1[3-9]\d{9}$/.test(formData.phone)) {
    showToast('请输入正确的手机号')
    return
  }

  try {
    // TODO: 调用获取验证码接口
    await getBindCardCode({
      bankAccountNo: formData.cardNumber,
      bankMobile: formData.phone
    }).then(res => {
      console.log(res)
      if (res.code === 200) {
        showToast('验证码已发送')
        authData.value.authSn = res.data.authSn
        authData.value.requestNo = res.data.requestNo
        // 开始倒计时
        counting.value = true
        countdown.value = 60
        timer = setInterval(() => {
          countdown.value--
          if (countdown.value <= 0) {
            counting.value = false
            if (timer) {
              clearInterval(timer)
              timer = null
            }
          }
        }, 1000)
      } else {
        showToast(res.msg)
      }
    })
  } catch (error) {
    console.error(error)
  }
}

// 提交表单
const submitForm = async () => {
  if (!validateForm()) return
  if (!authData.value.smsCode) {
    showToast('请输入验证码')
    return
  }

  try {
    // TODO: 调用提交表单接口
    await bindCard(authData.value).then(res => {
      console.log(res)
      if (res.code === 200) {
        showToast('添加银行卡成功')
        emit('close')
      } else {
        showToast(res.msg)
      }
    })
  } catch (error) {
    showToast('添加银行卡失败')
  }
}


// 获取银行卡列表
const getList = async () => {
  const res = await getBankList().then((res) => {
    if (res.code === 200) {
      bankList.value = res.data
    }
  })
}

onMounted(() => {
  getList()
})

// 组件销毁时清除定时器
onBeforeUnmount(() => {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
})

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_icon, {
      name: "cross",
      class: "close-icon",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
    }),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "header" }, [
      _createElementVNode("div", { class: "title" }, "添加银行卡"),
      _createElementVNode("div", { class: "subtitle" }, "请绑定持卡人本人的银行卡")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_field, {
        modelValue: formData.cardHolder,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.cardHolder) = $event)),
        label: "持卡人",
        placeholder: "持卡人姓名",
        border: false,
        "label-width": "60px"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_van_field, {
        modelValue: formData.cardNumber,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.cardNumber) = $event)),
        label: "卡号",
        placeholder: "持卡人本人银行卡号",
        border: false,
        "label-width": "60px"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_van_field, {
        modelValue: formData.phone,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.phone) = $event)),
        label: "手机号",
        placeholder: "持卡人银行预留手机号",
        border: false,
        "label-width": "60px"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_van_field, {
        modelValue: authData.value.smsCode,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((authData.value.smsCode) = $event)),
        label: "验证码",
        placeholder: "输入验证码",
        border: false,
        "label-width": "60px"
      }, {
        button: _withCtx(() => [
          _createVNode(_component_van_button, {
            size: "small",
            type: "primary",
            plain: "",
            class: "verify-btn",
            onClick: getVerificationCode,
            disabled: counting.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(counting.value ? `${countdown.value}s` : '获取验证码'), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_button, {
          type: "primary",
          block: "",
          class: "submit-btn",
          onClick: submitForm
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode(" 绑定银行卡 ")
          ])),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "list-title" }, "支持银行列表", -1)),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bankList.value, (bank, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "bank-item",
            key: index
          }, _toDisplayString(bank.bankName), 1))
        }), 128))
      ])
    ])
  ]))
}
}

})